export const getPools = (state) => state.pools || [];

export const findPoolById = (state, poolId) => (getPools(state).find(pool => pool.ID === poolId) || {});
